import { useMutation, useQuery } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetV1PortalProductsHistoryListParams,
  TGetV1PortalProductsHistoryListResponse,
  getV1PortalProductsHistoryList,
  TGetV1PortalLogPositionAdjustParams,
  TGetV1PortalLogPositionAdjustResponse,
  getV1PortalLogPositionAdjust,
  TPostV1PortalPublicListParams,
  TPostV1PortalPublicListResponse,
  postV1PortalPublicList,
  TDeleteV1PortalProductsOrdersParams,
  TDeleteV1PortalProductsOrdersResponse,
  deleteV1PortalProductsOrders,
  TDeleteV1PortalProductsBatchOrderParams,
  TDeleteV1PortalProductsBatchOrderResponse,
  deleteV1PortalProductsBatchOrder,
  TGetV1PortalCollectionParams,
  TGetV1PortalCollectionResponse,
  getV1PortalCollection,
  TGetV1PortalProductsConditionOrderListParams,
  TGetV1PortalProductsConditionOrderListResponse,
  getV1PortalProductsConditionOrderList,
  TGetV1PortalPositionListAllParams,
  TGetV1PortalPositionListAllResponse,
  getV1PortalPositionListAll,
  TGetV1PortalProductsConditionListParams,
  TGetV1PortalProductsConditionListResponse,
  getV1PortalProductsConditionList,
  TGetV1PortalPublicParams,
  TGetV1PortalPublicResponse,
  getV1PortalPublic,
  TPostV1PerpetualCollectionParams,
  TPostV1PerpetualCollectionResponse,
  postV1PerpetualCollection,
  TGetV1PerpetualCollectionParams,
  TGetV1PerpetualCollectionResponse,
  getV1PerpetualCollection,
  TGetV1DeliverCollectionParams,
  TGetV1DeliverCollectionResponse,
  getV1DeliverCollection,
  TPostV1DeliverCollectionParams,
  TPostV1DeliverCollectionResponse,
  postV1DeliverCollection,
  TPostV1PortalCollectionParams,
  postV1PortalCollection,
  TPostV1PortalCollectionResponse,
} from 'core/service/yapi/swap/Collection/api'
// collection-controller
// 历史委托
export const useGetV1PortalProductsHistoryListQuery = (
  params?: TGetV1PortalProductsHistoryListParams,
  options?: TUseQueryOptions<TGetV1PortalProductsHistoryListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalProductsHistoryList', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalProductsHistoryList(params),
  })
}

// 仓位调整记录
export const useGetV1PortalLogPositionAdjustQuery = (
  params?: TGetV1PortalLogPositionAdjustParams,
  options?: TUseQueryOptions<TGetV1PortalLogPositionAdjustResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalLogPositionAdjust', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalLogPositionAdjust(params),
  })
}

// 按条件查询合约列表
export const usePostV1PortalPublicListQuery = (
  params?: TPostV1PortalPublicListParams,
  options?: TUseQueryOptions<TPostV1PortalPublicListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalPublicList', 'POST'],
    queryFn: () => postV1PortalPublicList(params),
  })
}

// 批量撤单
export const useDeleteV1PortalProductsOrdersMutation = (
  mutationOptions?: TUseMutationOptions<TDeleteV1PortalProductsOrdersResponse, TDeleteV1PortalProductsOrdersParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Collection', 'V1PortalProductsOrders', 'Delete'],
    mutationFn: (params?: TDeleteV1PortalProductsOrdersParams) => deleteV1PortalProductsOrders(params),
  })
}

// 根据条件-批量撤单
export const useDeleteV1PortalProductsBatchOrderMutation = (
  mutationOptions?: TUseMutationOptions<
    TDeleteV1PortalProductsBatchOrderResponse,
    TDeleteV1PortalProductsBatchOrderParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Collection', 'V1PortalProductsBatchOrder', 'Delete'],
    mutationFn: (params?: TDeleteV1PortalProductsBatchOrderParams) => deleteV1PortalProductsBatchOrder(params),
  })
}

// 获取合约自选列表
export const useGetV1PortalCollectionQuery = (
  params?: TGetV1PortalCollectionParams,
  options?: TUseQueryOptions<TGetV1PortalCollectionResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalCollection', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalCollection(params),
  })
}

// 收藏合约
export const usePostV1PortalCollectionMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1PortalCollectionResponse, TPostV1PortalCollectionParams[]>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Collection', 'V1PortalCollection', 'Post'],
    mutationFn: (params?: TPostV1PortalCollectionParams[]) => postV1PortalCollection(params),
  })
}

// 条件委托
export const useGetV1PortalProductsConditionOrderListQuery = (
  params?: TGetV1PortalProductsConditionOrderListParams,
  options?: TUseQueryOptions<TGetV1PortalProductsConditionOrderListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalProductsConditionOrderList', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalProductsConditionOrderList(params),
  })
}

// 列出所有仓位
export const useGetV1PortalPositionListAllQuery = (
  params?: TGetV1PortalPositionListAllParams,
  options?: TUseQueryOptions<TGetV1PortalPositionListAllResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalPositionListAll', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalPositionListAll(params),
    select: (res) => res.data.data,
  })
}

// 条件委托
export const useGetV1PortalProductsConditionListQuery = (
  params?: TGetV1PortalProductsConditionListParams,
  options?: TUseQueryOptions<TGetV1PortalProductsConditionListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalProductsConditionList', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalProductsConditionList(params),
  })
}

// 按条件查询合约列表
export const useGetV1PortalPublicQuery = (
  params?: TGetV1PortalPublicParams,
  options?: TUseQueryOptions<TGetV1PortalPublicResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PortalPublic', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PortalPublic(params),
  })
}

// 设置合约自选
export const usePostV1PerpetualCollectionMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1PerpetualCollectionResponse, TPostV1PerpetualCollectionParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Collection', 'V1PerpetualCollection', 'Post'],
    mutationFn: (params?: TPostV1PerpetualCollectionParams) => postV1PerpetualCollection(params),
  })
}

// 获取合约自选
export const useGetV1PerpetualCollectionQuery = (
  params?: TGetV1PerpetualCollectionParams,
  options?: TUseQueryOptions<TGetV1PerpetualCollectionResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1PerpetualCollection', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1PerpetualCollection(params),
  })
}

// 获取合约自选
export const useGetV1DeliverCollectionQuery = (
  params?: TGetV1DeliverCollectionParams,
  options?: TUseQueryOptions<TGetV1DeliverCollectionResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Collection', 'V1DeliverCollection', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1DeliverCollection(params),
  })
}

// 设置合约自选
export const usePostV1DeliverCollectionMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1DeliverCollectionResponse, TPostV1DeliverCollectionParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Collection', 'V1DeliverCollection', 'Post'],
    mutationFn: (params?: TPostV1DeliverCollectionParams) => postV1DeliverCollection(params),
  })
}
